import React, { useEffect, useState } from 'react';
import { cargarCatalogoGlobal } from '../services/catalogo';

export const CatalogLoader = () => {
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const checkAndLoadCatalog = async () => {
      const catalogLoaded = localStorage.getItem('catalogoLoaded');
      
      if (!catalogLoaded) {
        setLoading(true);
        try {
          await cargarCatalogoGlobal();
          localStorage.setItem('catalogoLoaded', 'true');
          setLoaded(true);
        } catch (error) {
          console.error('Error cargando catálogo:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    checkAndLoadCatalog();
  }, []);

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: 9999
      }}>
        <h2>Cargando catálogo de productos...</h2>
        <p>Esto solo se hace una vez</p>
      </div>
    );
  }

  return null;
};